import { minutesToPercent, selectedSegments } from "../../../../../components/RRule/timeline-range.js";
import { evalClockFromPeriod } from "../../relative-window/relative-window-geometry.js";
import { cadenceSlotEnd, cadenceSlotStarts } from "./cadence-slots.js";
import React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/cadence/CadenceOccurrenceTrack.tsx
function CadenceOccurrenceTrack({ occurrence, periodFromMin, relativeDurationMinutes, relativeFromStartMinutes }) {
	if (occurrence.type !== "cadence") return null;
	return /* @__PURE__ */ jsx("div", {
		className: "relative h-[1lh] w-full",
		children: cadenceSlotStarts(relativeDurationMinutes, occurrence.cadenceMinutes).map((slotStart) => {
			const clock = evalClockFromPeriod(periodFromMin, relativeFromStartMinutes + slotStart);
			const tailDuration = cadenceSlotEnd(slotStart, occurrence.cadenceMinutes, occurrence.bufferMinutes, relativeDurationMinutes) - slotStart;
			const tailEndClock = evalClockFromPeriod(periodFromMin, relativeFromStartMinutes + slotStart + tailDuration);
			const tailSegments = tailDuration > 0 ? selectedSegments(clock, tailEndClock, tailDuration) : [];
			return /* @__PURE__ */ jsxs(React.Fragment, { children: [tailSegments.map((segment) => /* @__PURE__ */ jsx("div", {
				className: "bg-main-faded absolute top-1/2 h-xxs -translate-y-1/2 rounded-full",
				style: {
					left: `${minutesToPercent(segment.start)}%`,
					width: `${minutesToPercent(segment.end - segment.start)}%`
				}
			}, `${slotStart}-${segment.start}-${segment.end}`)), /* @__PURE__ */ jsx("span", {
				className: "bg-main absolute top-1/2 h-xs w-xs -translate-x-1/2 -translate-y-1/2 rounded-full",
				style: { left: `${minutesToPercent(clock)}%` }
			})] }, slotStart);
		})
	});
}
//#endregion
export { CadenceOccurrenceTrack };

//# sourceMappingURL=CadenceOccurrenceTrack.js.map